import axios from "axios";

const DEFAULT_API_URL =
    process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

const api = axios.create({
    baseURL: DEFAULT_API_URL,
});

// Let the browser set multipart boundaries for FormData requests.
delete api.defaults.headers.post["Content-Type"];

export function setAuthToken(token) {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Token ${token}`;
    } else {
        delete api.defaults.headers.common["Authorization"];
    }
}

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const url = error.config?.url || "";
            if (!url.includes("/api/auth/")) {
                window.dispatchEvent(new Event("auth:unauthorized"));
            }
        }
        return Promise.reject(error);
    },
);

export default api;
